export enum InvitationType {
  Umbrella = 'umbrella',
  User = 'user',
}
